import { EMAIL_DETAILS_FORM_FIELDS_MAP } from '../../../forms/EmailDetails/EmailDetails.fields';
import {
  ATTACHMENT_FIELD_KEYS,
  buildEmailList
} from '../../CreateSendoutDrawer/SendoutForm/SendoutForm.utils';

const buildDeclinationDetails = (_, formValues = {}) => ({
  declination_notes: formValues[FORM_FIELDS_MAP.Comments.key] || '',
  declined_fields: formValues[FORM_FIELDS_MAP.SendoverReasons.key] || []
});

const buildSendoverDecline = value => value || [];

const buildSendoverAttachments = (_, formValues = {}) => {
  const allAttachments = ATTACHMENT_FIELD_KEYS.flatMap(fieldKey => formValues?.[fieldKey] || []);

  return {
    candidate: [...allAttachments],
    sendout: [],
    toSend: [...allAttachments]
  };
};

export const SENDOVER_TEMPLATE_ID = 4;

export const FORM_FIELDS_MAP = {
  ...EMAIL_DETAILS_FORM_FIELDS_MAP,
  AccountableRecruiter: {
    ...EMAIL_DETAILS_FORM_FIELDS_MAP.AccountableRecruiter,
    paramKey: 'job_order_accountable_id',
    outboundAccesor: 'id'
  },
  Candidate: {
    ...EMAIL_DETAILS_FORM_FIELDS_MAP.Candidate,
    paramKey: 'candidate_id',
    outboundAccesor: 'id'
  },
  CandidateRecruiter: {
    key: 'candidateRecruiter',
    paramKey: 'candidate_accountable_id',
    outboundAccesor: 'id'
  },
  HiringAuthority: {
    ...EMAIL_DETAILS_FORM_FIELDS_MAP.HiringAuthority,
    paramKey: 'hiring_authority'
  },
  SendoverReasons: {
    key: 'sendoverReasons'
  },
  SendoverDecline: {
    key: 'sendoverReasons',
    paramKey: 'sendover_decline',
    outboundAccesor: buildSendoverDecline
  },
  Comments: {
    key: 'comments'
  },
  AutomaticReminder: {
    key: 'automaticReminder',
    paramKey: 'enableSendoverHaFollowUp'
  },
  CarbonCopy: {
    ...EMAIL_DETAILS_FORM_FIELDS_MAP.CarbonCopy,
    paramKey: 'cc_emails',
    outboundAccesor: buildEmailList
  },
  BlindCarbonCopy: {
    ...EMAIL_DETAILS_FORM_FIELDS_MAP.BlindCarbonCopy,
    paramKey: 'bcc_emails',
    outboundAccesor: buildEmailList
  },
  Attachments: {
    key: 'attachments',
    paramKey: 'attachments',
    outboundAccesor: buildSendoverAttachments
  },
  EmailSubject: {
    ...EMAIL_DETAILS_FORM_FIELDS_MAP.EmailSubject,
    paramKey: 'subject'
  },
  EmailBody: EMAIL_DETAILS_FORM_FIELDS_MAP.EmailBody,
  ResolvedEmailBody: EMAIL_DETAILS_FORM_FIELDS_MAP.ResolvedEmailBody,
  DeclinationDetails: {
    key: 'declinationDetails',
    paramKey: 'declination_details',
    outboundAccesor: buildDeclinationDetails
  }
};
